import * as agreements from '@modules/agreements/store/agreements.reducer';
import * as authorization from '@modules/authorization/store/authorization.reducer';
import * as conditions from '@modules/conditions/store/conditions.reducer';
import * as confirmation from '@modules/confirmation/store/confirmation.reducer';
import * as dynamicForm from '@modules/dynamic-form/store/dynamicForm.reducer';
import * as contracts from '@modules/order/store/contracts/contracts.reducer';
import * as proposal from '@modules/order/store/proposal/proposal.reducer';
import * as payments from '@modules/payment/store/payment.reducer';
import * as common from '@modules/shared/store/common.reducer';
import * as status from '@modules/status/store/status.reducer';
import * as userProfile from '@modules/user-profile/store/userProfile.reducer';
import * as documents from '@modules/documents/store/documents.reducer';
import * as scoring from '@modules/scoring/store/scoring.reducer';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
  authorization: authorization.AuthorizationState;
  common: common.CommonState;
  proposal: proposal.ProposalState;
  contracts: contracts.ContractsState;
  dynamicForm: dynamicForm.DynamicFormState;
  agreements: agreements.AgreementsState;
  conditions: conditions.ConditionsState;
  payments: payments.PaymentState;
  status: status.StatusState;
  confirmation: confirmation.ConfirmationState;
  userProfile: userProfile.UserProfileState;
  documents: documents.DocumentsState;
  scoring: scoring.RemoteUploadedQuestionnaireFilesObjectId;
}

export const AppReducer: ActionReducerMap<AppState> = {
  authorization: authorization.reducer,
  common: common.reducer,
  proposal: proposal.reducer,
  contracts: contracts.reducer,
  dynamicForm: dynamicForm.reducer,
  agreements: agreements.reducer,
  conditions: conditions.reducer,
  payments: payments.reducer,
  status: status.reducer,
  confirmation: confirmation.reducer,
  userProfile: userProfile.reducer,
  documents: documents.reducer,
  scoring: scoring.reducer,
};
